import { appendQueryParam } from "./helper";
import { CacheStoreKey } from "../enum/cacheStore.enum";
import { StorageService } from "../services/storage.service";

export const INIT_CACHE_STAMP = "0000000000000";
export const PRE_CACHE_TEXT = 'pre#';

export const appendTimeStamp = (
  url: string
) => {
  const t = new Date().getTime();
  return appendQueryParam(url, "stamp", `${t}`) ?? url;
};

// export const appendCacheStamp = (
//   url: string,
//   storeKey: CacheStoreKey
// ) => {
//   const cacheStamp = getCacheStamp(storeKey);
//   return appendQueryParam(url, "stamp", cacheStamp) ?? url;
// };

export const setCacheStamp = (storeKey: CacheStoreKey, val: string) => {
  StorageService.setItem(storeKey, val);
  return val;;
};

export const resetCacheStamp = (storeKey: CacheStoreKey) => {
  StorageService.setItem(storeKey, INIT_CACHE_STAMP);
  console.log(storeKey, INIT_CACHE_STAMP);
  return INIT_CACHE_STAMP;;
};

export const resetAllCacheStamps = () => {
  console.log('Reset full cache');
  Object.values(CacheStoreKey).forEach(val => {
    resetCacheStamp(val);
  })
};

export const getCacheStamp = (storeKey: CacheStoreKey): string => {
  let value = StorageService.getItem(storeKey);

  if (!value) {
    const today = new Date();
    value = today.getTime().toString();
    StorageService.setItem(storeKey, value);
  }
  return value;
};

